<div class="caption-bar">
  <div class="caption">Baustellen</div>
</div>
<lib-construction-sites></lib-construction-sites>
